import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ClerkProvider } from "@clerk/react";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!clerkPubKey) {
  // Fail loudly (not silently) when the build is missing the Clerk key — this is
  // the most common local-setup mistake and a blank screen is hard to debug.
  root.render(
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#1E1E1E",
        color: "#e8e0d0",
        fontFamily: "sans-serif",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 420 }}>
        <h1 style={{ color: "#48B64C", fontSize: 18, marginBottom: 12 }}>
          Configuration error
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.6 }}>
          <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> is not set. Add it to{" "}
          <code>frontend/.env</code> and restart the dev server.
        </p>
      </div>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={clerkPubKey}>
        <App />
      </ClerkProvider>
    </React.StrictMode>
  );
}
